import {isMobile, isIdNo} from '@/utils/validate'
export const Society = {
  data () {
    return {
      society: [],
      options: {},
      myinfo: {},
      currentIndex: 0,
      visible: false,
      detail: {},
      detailCache: {},
      formInfo: {},
      rules: {
        user_name: [{required: true, message: '请输入姓名', trigger:'blur'}],
        user_mobile: [{required: true, message: '请输入手机号', trigger:'blur'}, {validator:isMobile, trigger:'blur'}],
        // blood_type: [{ required: true, message: '请选择血型', trigger: 'select' }],
        user_id_card: [{validator: isIdNo, trigger:'blur'}],
        user_guardian_name: [{required: true, message: '请输入紧急联系人姓名', trigger:'blur'}],
        user_guardian_mobile: [{required: true, message: '请输入紧急联系电话', trigger:'blur'}, {validator: isMobile, trigger:'blur'}],
      },
      bloodTypes: [
        {key: '0', value: 'O型'},
        {key: '1', value: 'A型'},
        {key: '2', value: 'B型'},
        {key: '3', value: 'AB型'},
      ],
      sources: [
        {key: '1', value: '院内'},
        {key: '2', value: '院外'},
      ],
      institutes: [],
      info_loading: true,
      options_loading: true,
      modify_loading: true,
    }
  },
  mounted() {
    this.getMyInfo();
    this.getActivities();
    this.getInfoForModify();
  },
  methods: {
    formDebug() {
      console.log(this.formInfo);
    },
    getMyInfo() {
      this.info_loading = true;
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api&a=activity_get_my_info',{
        params:{
          is_web:1,
          user_token: localStorage.getItem('user_token'),
        }
      }).then(function(res){
        if(res.data.status==1){
          console.log(res.data.data);
          this.myinfo = res.data.data;
          if(this.myinfo.activity_name.length < 1) this.currentIndex = 1;
          this.info_loading = false;
        }else{
          alert(res.data.message);
        }
      },function(){
        console.log('activity_get_my_info请求失败');
      });
    },
    getActivities() {
      this.options_loading = true;
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api&a=activity_select_api', {
        params:{
          is_web:1,
          user_token: localStorage.getItem('user_token'),
        }
      }).then(function(res){
        if(res.data.status==1){
          this.options = res.data.data;
          this.society = [];
          for(var i in this.options) {
            if(this.options[i].is_checked) this.society.push(this.options[i].activity_id);
          }
          this.options_loading = false;
          // console.log(this.society);
        }else{
          alert(res.data.message);
        }
      },function(){
        console.log('activity_select_api请求失败');
      });
    },
    showDetail(activity_id) {
      if(undefined != this.detailCache[activity_id]) {
        this.detail = this.detailCache[activity_id];
        this.visible = true;
        return;
      }
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api&a=get_activity_detail_api', {
        params:{
          is_web:1,
          activity_id_for_detail: activity_id,
        }
      }).then(function(res){
        if(res.data.status==1){
          this.detail = res.data.data;
          this.detailCache[activity_id] = res.data.data;
          console.log(res.data.data);
          this.visible = true;
        }else{
          alert(res.data.message);
        }
      },function(){
        console.log('get_activity_detail_api请求失败');
      });
    },
    hideDetail() {
      this.visible = false;
    },
    selectActivity() {
      if(this.society.length < 1) {
        alert('请至少选择一项');
        return;
      }
      var activity_ids = this.society.sort().join(',');
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api&a=activity_join_api', {
        params: {
          is_web:1,
          activity_data: activity_ids,
          user_token: localStorage.getItem('user_token'),
        }
      }).then(function(res){
        if(res.data.status==1){
          this.currentIndex = 2;
        }else{
          alert(res.data.message);
        }
      },function(){
        console.log('get_activity_detail_api请求失败');
      });
    },
    setCurrentIndex(i) {
      this.currentIndex = i;
      if(0 == i) {
        this.getMyInfo();
      }
    },
    getInfoForModify() {
      this.modify_loading = true;
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api&a=actitity_user_info_api', {
        params:{
          is_web:1,
          user_token: localStorage.getItem('user_token'),
        }
      }).then(function(res){
        if(res.data.status==1){
          console.log(res.data.data);
          this.formInfo = res.data.data;
          this.modify_loading = false;
        }else{
          alert(res.data.message);
        }
      },function(){
        console.log('actitity_user_info_api请求失败');
      });
    },
    saveInfo() {
      this.$refs['formInfo'].validate(valid => {
        if (valid) {
          this.$http.post(this.$root.apiBaseUrl + '?g=api&m=api&a=actitity_user_info_update_api&is_web=1&user_token='+localStorage.getItem('user_token'), this.formInfo).then(function(res){
            if(res.data.status==1){
              this.currentIndex = 3;
            }else{
              alert(res.data.message);
            }
          },function(){
            console.log('actitity_user_info_update_api请求失败');
          });
        }
      });
    },
    userInstituteChange(value) {
      console.log('onChange', value);
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api&a=institute_list_api&search_val='+value).then(function(res){
        if(res.data.status==1){
          this.institutes = res.data.data;
        }else{
          console.log(res.data.message);
        }
      },function(){
        console.log('actitity_user_info_update_api请求失败');
      });
    }
  }
}